/**
 * @author Martin Albarracin
 * @file index.jsx
 * @description Video Calls View Page.
 */

// Dependencies
import AppCardLayout from '@nephro/components/AppCardLayout';

// Components
import VideoCalls from '@nephro/components/VideoCalls';
import { getStorageItem } from 'commons/helpers/storage-helper';
import { useParams } from 'react-router';

const VideoCallsView = () => {
  const patientInfo = getStorageItem('user');
  const { meetingId, key, secret } = useParams();
  return (
    <AppCardLayout>
      <>
        {patientInfo && meetingId ? (
          <VideoCalls
            meetingId={meetingId}
            name={patientInfo?.name || 'Vantive NefroPlus'}
            email={patientInfo?.email || ''}
            apiKey={key}
            apiSecret={secret}
          />
        ) : (
          <div></div>
        )}
      </>
    </AppCardLayout>
  );
};

export default VideoCallsView;
